import React from 'react';
import { useI18n } from '@/lib/i18n';
import { Lightning, Network, HandHeart, ShieldCheck, Sliders, Handshake } from '@phosphor-icons/react';

const BG_IMG = 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80';

const icons = [Lightning, Network, HandHeart, ShieldCheck, Sliders, Handshake];

export default function WhyUs() {
  const { t } = useI18n();
  return (
    <section id="whyus" data-testid="whyus-section" className="bg-[#0A1128] py-24 md:py-32 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.18]"
        style={{ backgroundImage: `url(${BG_IMG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1128] via-[#0A1128]/95 to-[#0A1128]" />
      <div className="absolute inset-0 grain opacity-40" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <div className="eyebrow text-[#C5A059] flex items-center gap-3">
            <span className="w-10 h-px bg-[#C5A059]" />
            {t.whyus.eyebrow}
          </div>
          <h2 className="heading-display mt-6 text-white text-3xl sm:text-4xl lg:text-5xl">{t.whyus.title}</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 mt-16 border border-white/5">
          {t.whyus.items.map((it, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="bg-[#0A1128]/85 backdrop-blur-sm hover:bg-[#12161F] p-10 transition-all duration-500 group relative min-h-[260px] flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <Icon size={32} weight="thin" className="text-[#C5A059]" />
                  <span className="text-[10px] tracking-[0.25em] text-white/30">0{i + 1}</span>
                </div>
                <h3 className="mt-10 text-white font-medium text-xl leading-snug">{it.t}</h3>
                <p className="mt-3 text-white/55 text-[15px] leading-relaxed">{it.d}</p>
                <div className="absolute bottom-0 left-0 h-px w-0 bg-[#C5A059] group-hover:w-full transition-all duration-700" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
